import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { env } from '../../../config/index';
import { Row, Col, Card, Form, Input, Upload, Button, Grid, Modal, Typography, Space, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { useBreakpoint } = Grid;

function PaymentConfirmation() {
  const [form] = Form.useForm();
  const [paymentProofFile, setPaymentProofFile] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  const { xs } = useBreakpoint()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const handleUpload = () => {
    return {
      withCredentials: true,
      accept:".jpg, .jpeg, .pdf, .png",
      beforeUpload: file => {
        const validateSize = file.size >= 500000;
        if (validateSize) {
          message.error('Max file size is 500 KB!');
          return false
        }
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          setPaymentProofFile(file)
          message.info('Upload Success!');
        }
        return false;
      },
    }
  }

  const onFinish = (values) => {
    values.paymentProofFile = paymentProofFile

    const data = new FormData();
    for (const [val, name] of Object.entries(values)) {
      data.append(val, name);
    }

    if(paymentProofFile){
      setSubmitLoading(true)
      setTimeout(() => {
        axios.post(`${env}/wchss/upload_payment`, data, {
          headers: {
            'Cache-Control': 'no-cache',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => {
          const { code } = response.data
          if(code === 1000){
            // message.success('Payment Confirmation Success!')
            Modal.success({
              title: 'Payment Confirmation Success!',
              content: <Text>Your transfer proof has been Uploaded. We will check your transaction in <Text strong>3x24</Text> hours</Text>,
              onOk() {},
            });
            setSubmitLoading(false)
            form.setFieldsValue({ transactionNumber: null })
            setPaymentProofFile(null)
          }else{
            message.error('General Error!')
            setSubmitLoading(false)
          }
        }).catch(error => {
          message.error(error.message)
          setSubmitLoading(false)
        })
      }, 500);
    }else{
      message.error('Transfer Evidence is required')
    }
  }

  const onFinishFailed = (errorInfo) => {
    message.error(errorInfo);
  }

  const fileList = [
    {
      uid: '1',
      name: paymentProofFile?.name,
    }
  ]

  const handleRemove = (file) => {
    setPaymentProofFile(null)
    message.success(`${file.name} file removed successfully`);
  }

  return (
    <React.Fragment>
      <Row style={{ marginTop: xs ? 8 : 64 }}>
        <Col xs={{ span: 24 }} lg={{ span: 16, offset: 4 }}>
          <Card style={{ borderRadius: 8 }}>
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              style={{ marginTop: xs ? 8 : 32 }}
            >
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 16, offset: 4 }}>
                  <Space size={4} style={{ marginBottom: 4 }}>
                    <Text className="fs-12" type="danger">*</Text>
                    <Text className="fs-12">Registration Number</Text>
                  </Space>
                  <Form.Item name="transactionNumber" rules={[{ required: true, message: 'This field is required' }]}>
                    <Input />
                  </Form.Item>
                  <Space size={4} style={{ marginBottom: 4 }}>
                    <Text className="fs-12" type="danger">*</Text>
                    <Text className="fs-12">Transfer Evidence</Text>
                  </Space>
                  <Form.Item>
                    <Upload {...handleUpload()} maxCount={1} fileList={paymentProofFile ? fileList : null} onRemove={handleRemove}>
                      <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType='submit' block loading={submitLoading}>Submit</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default PaymentConfirmation